import { Controller } from '@hotwired/stimulus'

const INTERACTIVE_ELEMENTS = 'a, button, input, select, textarea, [role="button"]'

export default class extends Controller {
  navigate(event) {
    if (event.target.closest(INTERACTIVE_ELEMENTS)) return

    const row = event.target.closest('tr[data-row-url]')
    if (!row) return

    const url = row.dataset.rowUrl

    if (event.ctrlKey || event.metaKey) {
      window.open(url, '_blank')
    } else if (window.Turbo) {
      window.Turbo.visit(url)
    } else {
      window.location.href = url
    }
  }
}
